import { ApiError } from './api-client';
import { phrase } from './i18n/runtime';

export const VERSION_CONFLICT_MESSAGE =
  'This record was changed by someone else. Reload and try again.';

/** User-facing text for an error. Server messages are written for end users and safe to show. */
export function errorMessage(error: unknown): string {
  if (!(error instanceof ApiError)) {
    return 'Something went wrong. Please try again.';
  }
  if (error.code === 'VERSION_CONFLICT') {
    return VERSION_CONFLICT_MESSAGE;
  }
  if (error.code === 'RATE_LIMITED') {
    return 'Too many attempts. Please wait a few minutes and try again.';
  }
  if (error.code === 'NETWORK_ERROR') {
    return 'The server could not be reached. Check your connection and try again.';
  }
  if (error.code === 'INVALID_RESPONSE') {
    return 'The server sent an unexpected response. Please try again later.';
  }
  if (error.code === 'SERVICE_UNAVAILABLE' && error.message.trim() !== '') {
    return error.requestId !== undefined
      ? `${phrase(error.message)} ${phrase('Reference:')} ${error.requestId}`
      : phrase(error.message);
  }
  if (error.code === 'INTERNAL_ERROR' || error.code === 'SERVICE_UNAVAILABLE') {
    return error.requestId !== undefined
      ? `${phrase('Something went wrong on our side.')} ${phrase('Reference:')} ${error.requestId}`
      : 'Something went wrong on our side. Please try again later.';
  }
  return error.message;
}
